module.exports = __webpack_public_path__ + "static/media/04n.542c94b8.png";